import React from 'react';
import { Card, Typography, Box } from '@mui/material';

/**
 * A reusable card component for displaying key statistics.
 * @param {object} props - The component props.
 * @param {string} props.title - The title of the statistic (e.g., "Total Applications").
 * @param {string} props.value - The value of the statistic (e.g., "1,284").
 * @param {React.ReactElement} props.icon - The icon element to display.
 * @param {string} props.color - The linear-gradient string for the icon's background.
 * @returns {React.ReactElement} The StatCard component.
 */
const StatCard = ({ title, value, icon, color }) => {
  return (
    <Card sx={{
      display: 'flex',
      alignItems: 'center',
      padding: 2,
      // The hover effect is inherited from the global theme override in theme.js
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 64,
        height: 64,
        minWidth: 64, // prevent shrinking
        borderRadius: '50%',
        marginRight: 2,
        background: color,
        boxShadow: '0 4px 12px -4px rgba(0,0,0,0.3)',
      }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary" noWrap>
          {title}
        </Typography>
        <Typography variant="h5" fontWeight="bold" noWrap>
          {value}
        </Typography>
      </Box>
    </Card>
  );
};

export default StatCard;